module.exports = __webpack_public_path__ + "img/symbol_8.42688f18.png";